/**
 * Settings → Notifications (SAD-954): the signed-in person's own choices,
 * per kind, on top of the company defaults. Saved as each control changes —
 * there is no separate Save step for this section.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraInlineBanner, SpecraSpinner } from '@mono/ui-components';
import { toast } from 'sonner';
import { NotificationPreferencesTable } from '../../../components/notifications/NotificationPreferencesTable';
import { useMyNotificationPreferences, useUpdateMyNotificationPreferences } from '../../../components/notifications/preferencesHooks';
import { useAuth } from '../../../contexts/authContext';
export function NotificationSettings() {
    const { user } = useAuth();
    const companyId = user?.tenant_id ?? '';
    const { data: kinds, isLoading, error } = useMyNotificationPreferences(companyId);
    const update = useUpdateMyNotificationPreferences(companyId);
    const onUpdate = (u)=>update.mutate(u, {
            onSuccess: ()=>toast.success(u.resetAll ? 'Notifications reset to defaults' : 'Saved'),
            onError: (e)=>toast.error(e instanceof Error ? e.message : 'Could not save')
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-lg font-medium text-foreground",
                        children: "Notifications"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-muted-foreground",
                        children: "Choose what reaches your bell and your inbox. Daily digest sends one email a day with everything since the last one."
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ _jsx(SpecraSpinner, {}),
            error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                title: "Could not load your notification settings",
                children: error instanceof Error ? error.message : String(error)
            }),
            kinds && /*#__PURE__*/ _jsx(NotificationPreferencesTable, {
                kinds: kinds,
                ownSource: "PERSONAL",
                onUpdate: onUpdate,
                pending: update.isPending
            })
        ]
    });
}
